<template>
  <v-container>
    <v-card class="elevation-2 mx-auto" :loading="loading" max-width="600">
      <v-card-title>Edit Category</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <form>
          <v-row>
            <v-col cols="12" md="12" sm="12" class="py-0">
              <v-switch
                v-model="subcategory"
                label="Sub category"
                class="ma-0"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" class="py-0">
              <treeselect 
                class="my-6"
                v-if="subcategory"
                v-model="form_data.parent" 
                :multiple="false" 
                :options="parent_category"
                name="demo"
                :default-expand-level="2"
              >
                <label slot="option-label" slot-scope="{ node, labelClassName }" :class="labelClassName">
                  {{ node.raw.name }}
                </label>
                <div slot="value-label" slot-scope="{ node }">{{ node.raw.name }}</div>
              </treeselect>
               <!-- <v-select
                  :items="parent_category"
                  item-text="name"
                  item-value="id"
                  v-if="form_data.is_parent"
                  v-model="form_data.parent_category"
                  :error-messages="form_error.parent_category"
                  label="Parent Category"
                  dense
                  outlined
                ></v-select> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" class="py-0">
              <v-text-field
                label="Category"
                v-model="form_data.name"
                :error-messages="form_error.name"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-btn
            class="mr-4"
            color="secondary"
            @click="upadteCategory"
            :loading="loading"
            :disabled="loading"
          >Update</v-btn>
        </form>
      </v-card-text>
    </v-card>
    <v-btn small color="secondary" fixed fab bottom left to="/category">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
  </v-container>
</template>
<script>
import Treeselect from '@riophae/vue-treeselect'
  // import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { mapMutations } from "vuex";
export default {
  name: "EditObject",
  data() {
    return {
      pages: [],
      positions: [],
      subcategory : false,
      form_data: {},
      form_error: {},
      loading: false,
      data: {},
      parent_category : []
    };
  },
  components: { Treeselect },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    getParentCategory(){
      this.$axios.get('admin/category/get_parent?pagination=false&subcategory=true').then((response)=>{
        if(response?.data?.data){
          console.log('response.data.data',response.data.data)
          this.parent_category = response.data.data
        }
      })
    },
    getCategoryDetails() {
      this.loading = true;
      let _self = this;      
      this.$axios.get(`admin/category/details/${this.$route.params.id}`)
        .then((res) => {
          _self.form_error = {};
          if (res.status) {
            let data = res.data.data;
            this.subcategory = data.parent ? true : false;
            for (let key in data) {
              _self.form_data[key] = data[key];
            }
          } else {
            let errors = res.error;
            for (let key in errors) {
              console.log(errors[key]);
              _self.form_error[errors[key].field] = errors[key].message;
            }
          }
          console.log(_self.form_data);
          _self.loading = false;
        })
        .catch((e) => {
          console.log(e);
          _self.loading = false;
        });
    },
    upadteCategory() {
      let _self = this;
      this.loading = "secondary";
      _self.form_data.categoryId = _self.form_data.id
      this.$axios.put(`admin/category/edit/${this.$route.params.id}`, _self.form_data)
        .then((response) => {
          _self.form_error = {};
          let response_data = response.data;
          if (response_data.status) {
            _self.setAlert({
              show: true,
              variant: "success",
              message: response.data.message,
              dismissCountDown: 5000,
            });
            this.user_data = response_data.user_data;
            _self.$router.push("/category");
          } else {
            let errors = response_data.error;
            for (let key in errors) {
              _self.form_error[errors[key].field] = errors[key].message;
            }
          }
          _self.loading = false;
        })
        .catch((e) => {
          console.log(e);
          _self.loading = false;
        });
    },
  },
  mounted: function () {
    this.getParentCategory()
    this.getCategoryDetails();    
  },
};
</script>